import { FormEvent, useState } from "react";
import { Alert, Button, Col, Form, FormControl, InputGroup, Row, Spinner } from "react-bootstrap";
import { focusInput, focusoutInput } from "./utils";
import AuthService from "../../services/auth.service"
import { useLocalStorage } from "utils";
import Icon from "components/Icon";

interface Params{
  move: Function,
}

export default function FormLogin({ move }:Params) {
  const [ token, setToken ] = useLocalStorage("token",null);
  const [ loading, setLoading ] = useState(false);

  const handleFormSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    setLoading(true);
    ev.preventDefault();
    let formData = new FormData(ev.currentTarget)
    AuthService.login(formData)
      .then((res: any) => {
        setToken(res);
      })
      .catch((error)=>{
        let ael = document.getElementById("alert_error_login");
        if(ael){
          // ael.innerText = error;
          ael.className = "fadein";
          setTimeout(()=>{
            if(ael)
            ael.className = "fadeout";
          },5000);
          setLoading(false);
        }
      })
  }

  if(token){
    let load = document.getElementById('load-root');
    if(load) {
      load.style.display = "";
      setTimeout(() =>{
        if(load)
        load.classList.remove("removing");
      },1);
    }
    setTimeout(() =>{
      window.location.reload();
    },1500);
  }

  return (<>
    <div id="alert_error_login">
      <Alert variant="danger">
        E-mail e/ou senha inválido(s).
      </Alert>
    </div>
    <Form onSubmit={handleFormSubmit}>
      <Row>
        <h2>Login</h2>
        <Col xs="12" className="mt-2">
          <Form.Label htmlFor="mail" >
            E-mail
          </Form.Label>
          <InputGroup className="mb-2">
            <InputGroup.Text className="input-icon"><Icon name="at"/></InputGroup.Text>
            <FormControl required id="mail" name="email" placeholder="E-mail" type="email"
              onFocus={({target})=>focusInput(target)}
              onBlur={({target})=>focusoutInput(target)}
            />
          </InputGroup>
        </Col>
        <Col xs="12" className="mt-2">
          <Form.Label htmlFor="pass">
            Senha
          </Form.Label>
          <InputGroup className="mb-2">
            <InputGroup.Text className="input-icon"><Icon name="unlock-alt"/></InputGroup.Text>
            <FormControl required id="pass" name="password" placeholder="Senha" type="password" 
              onFocus={({target})=>focusInput(target)}
              onBlur={({target})=>focusoutInput(target)}
            />
          </InputGroup>
        </Col>
        <Form.Group className="col mb-3" style={{fontSize: `14px`}}>
          <Form.Check type="checkbox" name="remenber" label="Continuar conectado" />
        </Form.Group>
        <Form.Group className="col-auto mb-3" style={{fontSize: `14px`}}>
          <Form.Label id="forget-password-btn" onClick={()=>move()}>Esqueceu a senha?
            <div id="icon-forget-password-btn"><Icon name="chevron-right"/></div>
          </Form.Label>
        </Form.Group>

        <Col xs="12" className="mt-3 center text-center">
          {loading?(
            <Spinner animation="border"/>
          ):(
            <Button type="submit" className="w-100">Acessar</Button>
          )}
        </Col>
      </Row>
    </Form>
  </>)
}